<template>
  <svg
    width="27"
    height="28"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 16.25C14.7426 16.25 15.75 15.2426 15.75 14C15.75 12.7574 14.7426 11.75 13.5 11.75C12.2574 11.75 11.25 12.7574 11.25 14C11.25 15.2426 12.2574 16.25 13.5 16.25Z"
    />
    <path
      d="M21.375 16.25C22.6176 16.25 23.625 15.2426 23.625 14C23.625 12.7574 22.6176 11.75 21.375 11.75C20.1324 11.75 19.125 12.7574 19.125 14C19.125 15.2426 20.1324 16.25 21.375 16.25Z"
    />
    <path
      d="M5.625 16.25C6.86764 16.25 7.875 15.2426 7.875 14C7.875 12.7574 6.86764 11.75 5.625 11.75C4.38236 11.75 3.375 12.7574 3.375 14C3.375 15.2426 4.38236 16.25 5.625 16.25Z"
    />
  </svg>
</template>
